import { styled } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import { Box, List } from '@montugroup/design-system';
import type { Theme } from '@mui/material/styles';

export const DRAWER_WIDTH = 256;
export const DRAWER_WIDTH_COLLAPSED = 77;

interface AppDrawerProps {
  open?: boolean;
}

const openedMixin = (theme: Theme) => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: DRAWER_WIDTH_COLLAPSED,
});

export const StyledAppDrawer = styled(SwipeableDrawer)<AppDrawerProps>(({ theme, open }) => ({
  width: open ? DRAWER_WIDTH : DRAWER_WIDTH_COLLAPSED,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
  }),
  whiteSpace: 'nowrap',
  '& .MuiDrawer-paper': {
    ...(open ? openedMixin(theme) : closedMixin(theme)),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

export const StyledNavContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(14),
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
}));

export const StyledNavContainerInner = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  transition: '0.3s',
}));

export const StyledListContainer = styled(List)`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 0;
`;
